// extracted by mini-css-extract-plugin
export default {"container":"ProductManagement_container__85wW1","title":"ProductManagement_title__oIRrT"};